module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg1-7e3bd3aabbaa9bf50a27775a7003bc46.jpg";